import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    flex: 1,
    borderRadius: theme.borderRadius.l,
  },

  content: ({ pressed }: { pressed: boolean }) => ({
    flex: 1,
    paddingLeft: theme.spacing[4],
    paddingVertical: theme.spacing[5],
    borderRadius: theme.borderRadius.l,
    borderWidth: 1.5,
    borderColor: colors.borderPrimary,
    variants: {
      state: {
        default: {
          backgroundColor: pressed ? colors.backgroundL1Alpha : 'transparent',
          borderColor: pressed ? colors.backgroundL1Alpha : colors.backgroundL1,
        },
        main: {
          backgroundColor: colors.backgroundBrand,
          borderWidth: 2.5,
          borderColor: colors.borderSubtle,
        },
        additional: {
          backgroundColor: colors.backgroundL1Alpha,
          borderColor: colors.backgroundL1Alpha,
        },
      },
    },
  }),

  selectedIconContainer: {
    position: 'relative',
    top: -theme.spacing[7],
    right: -theme.spacing[4],
    alignItems: 'center',
    justifyContent: 'center',
    height: 30,
    width: 30,
    borderRadius: theme.borderRadius.full,
    borderWidth: 0,
    backgroundColor: colors.textPrimary,
  },

  withDescription: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: colors.backgroundL0,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    height: 'auto',
    zIndex: 10,
  },

  header: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },

  giftIconWrapper: {
    flexShrink: 0,
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    paddingRight: theme.spacing[2],
    paddingLeft: theme.spacing[2],
  },

  serviceInfo: {
    width: '80%',
  },

  duration: {
    marginRight: theme.spacing[3],
  },

  price: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'absolute',

    right: 0,
    bottom: theme.spacing[6],
    paddingVertical: theme.spacing[2],
    paddingHorizontal: theme.spacing[4],
    borderTopLeftRadius: theme.borderRadius.xs,
    borderBottomLeftRadius: theme.borderRadius.xs,
    width: 'auto',

    variants: {
      state: {
        default: {
          backgroundColor: colors.backgroundL1,
          color: colors.textBrand,
        },
        main: {
          backgroundColor: colors.backgroundL1Selected,
          color: colors.textPrimary,
        },
        additional: {
          backgroundColor: colors.backgroundL1,
          color: colors.textPrimary,
        },
      },
    },
  },

  infoButton: {
    borderRadius: theme.borderRadius.s,
    borderWidth: 0,
    position: 'absolute',
    top: -theme.spacing[4],
    right: 1,
  },

  description: {
    marginTop: theme.spacing[3],
    paddingVertical: theme.spacing[5],
    paddingRight: theme.spacing[4],
  },
  priceSpacer: (height: number) => ({
    height: height + theme.spacing[6],
  }),

  modalOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    // backgroundColor: colors.overlayPrimary,
    zIndex: 10,
  },
}));
